export default "__VITE_ASSET__Cg3gDbK7__"